import { AppState, picoapp } from "picoapp";
import * as components from "./components";
import * as pageComponents from "./pages";

const initialState: AppState = {
  products: {},
  dialogs: {},
};

const app = picoapp({ ...components, ...pageComponents }, initialState);

window.addEventListener("DOMContentLoaded", function () {
  app.mount();
});

window.addEventListener("shopify:section:load", () => {
  app.mount();
});

window.addEventListener("picoapp:mount", () => {
  app.mount();
});

export default app;
